import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Instagram, Facebook } from 'lucide-react';

const TikTokIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12.75 2a.75.75 0 0 1 .75-.75h2.5A6.25 6.25 0 0 0 22.25 7.5v1.125a.75.75 0 0 1-.75.75h-1.125a6.25 6.25 0 0 1-6.25-6.25V2.75a.75.75 0 0 0-.75-.75h-.625ZM9.5 9.75a4.75 4.75 0 1 0 3.25 8.207v2.293a7 7 0 1 1 2.25-13.019v7.269a4.75 4.75 0 0 1-5.5-4.75Z"/>
  </svg>
);

const Contact = () => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('¡Mensaje enviado! Gracias por contactarnos.');
    setMessage('');
  };

  const contactInfo = [
    { icon: Mail, label: 'Correo', value: 'ratonesviajeros3@gmail.com' },
    { icon: Phone, label: 'Teléfono', value: '+52 1 33 1406 6489' },
  ];

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          className="text-4xl font-bold text-center text-gray-800 mb-12 bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Contáctanos
        </motion.h2>
        
        <div className="grid md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Información de Contacto</h3>
            <div className="space-y-4">
              {contactInfo.map((item, index) => {
                const Icon = item.icon;
                return (
                  <motion.div
                    key={index}
                    className="flex items-center space-x-4 p-4 bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <div className="p-2 bg-pink-100 rounded-xl">
                      <Icon className="w-5 h-5 text-pink-600" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-700">{item.label}</p>
                      <p className="text-gray-600">{item.value}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
            
            {/* Redes Sociales */}
            <div className="flex space-x-4 mt-8">
              <a 
                href="https://www.instagram.com/ratones.viajeros?igsh=Zzhycmt2b2o5NXNp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-3 bg-pink-500 rounded-full text-white hover:bg-pink-600 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.facebook.com/share/1JhUwP6GkH/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-3 bg-blue-600 rounded-full text-white hover:bg-blue-700 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@ratones.viajeros" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-3 bg-black rounded-full text-white hover:bg-gray-800 transition-colors"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Envíanos un Mensaje</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                placeholder="Tu nombre"
                className="w-full p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-pink-500"
                required
              />
              <input
                type="email"
                placeholder="Correo electrónico"
                className="w-full p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-pink-500"
                required
              />
              <textarea
                placeholder="Tu mensaje"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-pink-500 resize-none"
                required
              ></textarea>
              <motion.button
                type="submit"
                className="w-full bg-gradient-to-r from-pink-500 to-purple-600 text-white py-3 rounded-2xl font-semibold"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Enviar Mensaje
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
